import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { catchError, delay, filter, Subscriber, Subscription, switchMap } from 'rxjs';
import { ListarPacientesEntrada } from 'src/app/dtos/pacientes/listar-pacientes-entrada';
import { PacienteDto } from 'src/app/dtos/pacientes/paciente-dto';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { ModalPesquisaService } from '../base-pesquisa/modal-pesquisa.service';

interface ListarPacientesForm {
  nomeCpf: FormControl<string>;
  lotacoesFechadas: FormControl<boolean>;
}

@Component({
  selector: 'app-paciente-pesquisa',
  templateUrl: './paciente-pesquisa.component.html',
  styleUrls: ['./paciente-pesquisa.component.less'],
  providers: [ModalPesquisaService]
})
export class PacientePesquisaComponent implements OnInit {
  
  @Output()
  registroSelecionado: EventEmitter<PacienteDto> = new EventEmitter<PacienteDto>();

  registros: Object | null = null;

  modelo: FormGroup<ListarPacientesForm> = this.fb.nonNullable.group({
    nomeCpf: [''],
    lotacoesFechadas: [false]
  });

  subs: Subscription | null = null;

  constructor(private modalServico: ModalPesquisaService, private fb: FormBuilder,
    private toast: ToastService,
    public pacienteServico: PacienteService) { }

  ngOnInit(): void {
  }

  abrir(pesquisa: string = '') {
    this.registarSubs();
    this.modalServico.abrirTelaCheia();

    if(pesquisa) {
      this.modelo.controls.nomeCpf.setValue(pesquisa);
    }
  }

  registarSubs() {
    if(this.subs !== null)
      this.subs.unsubscribe();

    this.subs = this.modelo.valueChanges
    .pipe(
      delay(400),
      filter(valor => {
        return valor.nomeCpf !== undefined && (valor.nomeCpf.length >= 3);
      }),
      switchMap(valor => {
        return this.pacienteServico.listarPacientes(new ListarPacientesEntrada({ nomeCpf: valor.nomeCpf, 
        lotacoesFechadas: valor.lotacoesFechadas ?? false }));
      }),
      catchError((err) => {
        this.toast.showError('Ops, ocorreu um problema ao realizar a requisição.');
        this.registarSubs();
        throw err;
      })
    )
    .subscribe(valor => {
      this.registros = valor;
    });
  }

  pacienteSelecionado(paciente: PacienteDto) {
    this.pacienteServico.carregarPaciente(paciente.id).subscribe();
    this.registroSelecionado.emit(paciente)
  }
}
